/**
 * Minimalerei Stories — Listing JS
 *
 * - Filter (Tags)
 * - Sort (Newest / Oldest)
 * - Load More (AJAX)
 */

(function () {
  'use strict';

  const SELECTORS = {
    listing: '[data-mp-stories-listing]',
    grid: '[data-mp-stories-grid]',
    filterPills: '[data-mp-filter-pills]',
    filterPill: '[data-mp-filter]',
    sortSelect: '[data-mp-sort-select]',
    loadMoreBtn: '[data-mp-load-more-btn]',
    loadMoreWrap: '[data-mp-load-more-wrap]',
    emptyState: '[data-mp-empty-state]',
    emptyReset: '[data-mp-empty-reset]',
    storyCard: '.mp-story-card',
    currentCount: '[data-mp-current-count]',
    totalCount: '[data-mp-total-count]',
  };

  function initListing(listing) {
    const blogHandle = listing.dataset.blogHandle;
    const articlesPerPage = parseInt(listing.dataset.articlesPerPage, 10) || 6;
    const grid = listing.querySelector(SELECTORS.grid);
    const loadMoreBtn = listing.querySelector(SELECTORS.loadMoreBtn);
    const loadMoreWrap = listing.querySelector(SELECTORS.loadMoreWrap);
    const emptyState = listing.querySelector(SELECTORS.emptyState);
    const emptyReset = listing.querySelector(SELECTORS.emptyReset);
    const filterPills = listing.querySelectorAll(SELECTORS.filterPill);
    const sortSelect = listing.querySelector(SELECTORS.sortSelect);
    const currentCountEl = listing.querySelector(SELECTORS.currentCount);
    const totalCountEl = listing.querySelector(SELECTORS.totalCount);

    let currentFilter = 'all';
    let currentSort = 'newest';
    let allCardsLoaded = false;

    function updateCount() {
      const allCards = grid.querySelectorAll(SELECTORS.storyCard);
      const visibleCards = Array.from(allCards).filter(function (card) {
        return !card.classList.contains('is-hidden');
      });

      if (currentCountEl) {
        currentCountEl.textContent = visibleCards.length;
      }
    }

    function applyFilter() {
      const cards = grid.querySelectorAll(SELECTORS.storyCard);
      let visibleCount = 0;

      cards.forEach(function (card) {
        const cardTags = (card.dataset.mpStoryTags || '').split(' ');
        const shouldShow = currentFilter === 'all' || cardTags.includes(currentFilter);

        if (shouldShow) {
          card.classList.remove('is-hidden');
          visibleCount++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (visibleCount === 0) {
        emptyState.style.display = 'block';
        grid.style.display = 'none';
      } else {
        emptyState.style.display = 'none';
        grid.style.display = '';
      }

      updateCount();
    }

    function applySort() {
      const cards = Array.from(grid.querySelectorAll(SELECTORS.storyCard));

      cards.sort(function (a, b) {
        const dateA = parseInt(a.dataset.mpStoryDate, 10) || 0;
        const dateB = parseInt(b.dataset.mpStoryDate, 10) || 0;

        if (currentSort === 'newest') {
          return dateB - dateA;
        } else {
          return dateA - dateB;
        }
      });

      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function loadMore() {
      if (allCardsLoaded) return;

      const nextPage = parseInt(loadMoreBtn.dataset.mpPage, 10);
      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.disabled = true;

      const url = '/blogs/' + blogHandle + '?page=' + nextPage;

      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error');
          return response.text();
        })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCards = doc.querySelectorAll(SELECTORS.storyCard);

          if (newCards.length === 0) {
            allCardsLoaded = true;
            loadMoreWrap.classList.add('is-hidden');
          } else {
            const featuredCard = listing.querySelector('.mp-story-featured');
            const featuredHandle = featuredCard ? featuredCard.dataset.mpStoryHandle : '';
            const existingHandles = Array.from(grid.querySelectorAll(SELECTORS.storyCard))
              .map(function (c) { return c.dataset.mpStoryHandle; });

            let addedCount = 0;
            newCards.forEach(function (card) {
              const handle = card.dataset.mpStoryHandle;

              if (handle === featuredHandle) return;
              if (existingHandles.indexOf(handle) !== -1) return;

              grid.appendChild(card);
              addedCount++;
            });

            if (addedCount === 0) {
              allCardsLoaded = true;
              loadMoreWrap.classList.add('is-hidden');
            } else {
              loadMoreBtn.dataset.mpPage = nextPage + 1;
              applyFilter();
              applySort();
            }
          }
        })
        .catch(function (error) {
          console.error('Load more error:', error);
        })
        .finally(function () {
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.disabled = false;
        });
    }

    filterPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        filterPills.forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');

        currentFilter = pill.dataset.mpFilter;
        applyFilter();
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentSort = sortSelect.value;
        applySort();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', loadMore);
    }

    if (emptyReset) {
      emptyReset.addEventListener('click', function () {
        filterPills.forEach(function (p) {
          p.classList.remove('is-active');
        });
        const allPill = listing.querySelector('[data-mp-filter="all"]');
        if (allPill) allPill.classList.add('is-active');

        currentFilter = 'all';
        applyFilter();
      });
    }

    function init() {
      if (totalCountEl) {
        const totalCards = grid.querySelectorAll(SELECTORS.storyCard).length;
        const hasFeatured = listing.querySelector('.mp-story-featured') !== null;
        totalCountEl.textContent = totalCards + (hasFeatured ? 1 : 0);
      }

      updateCount();
    }

    init();
  }

  function initAll() {
    const listings = document.querySelectorAll(SELECTORS.listing);
    listings.forEach(initListing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
